import { render, staticRenderFns } from "./CapacitorInput.vue?vue&type=template&id=9bd48fbc&scoped=true"
import script from "./CapacitorInput.vue?vue&type=script&lang=ts"
export * from "./CapacitorInput.vue?vue&type=script&lang=ts"
import style0 from "./CapacitorInput.vue?vue&type=style&index=0&id=9bd48fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd48fbc",
  null
  
)

export default component.exports